import React from 'react';
import Banner from '../../components/Banner/Banner';
import './About.css';

// Import images
import molybdenumImage from '../../assets/images/AF3280DF-1A22-4A61-AD88-D75F363FA720.jpeg';
import compositeImage from '../../assets/images/021EAB6C-1B64-47E9-91A0-CE6E26A98F93.jpeg';
import awardImage1 from '../../assets/images/odul-konusma.jpg';
import awardImage2 from '../../assets/images/odul-bakan.jpg';

const About = () => {
  return (
    <>
      <Banner title="Hakkımızda" />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="about-content">
              <section className="company-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="section-title">Teknoma Teknolojik Malzemeler San. ve Tic. Ltd. Şti.</h4>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="company-info-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="company-description">
                        <p>TEKNOMA Teknolojik Malzemeler San. ve Tic. Ltd. Şti., İzmir Yüksek Teknoloji Enstitü (İYTE) kampüsünde kurulu olan İzmir Teknoloji Geliştirme Bölgesi (IZTEKGEB) bünyesinde yer alan bir kuruluştur. TEKNOMA, Ar-Ge esaslı faaliyet ve danışmanlık hizmetleri sunma misyonuna sahiptir.</p>
                        <p>Faaliyet konularını; Teknolojik Malzemeler, Savunma Sanayi Malzemeleri, İnce Filmler ve Yüzey Kaplamaları, Vakum Teknolojileri, Kompozit ve Polimerik Malzemelerin Metalizasyonu oluşturmaktadır.</p>
                        <p>Kompozit malzemelerin metalizasyonu, radar soğurması ve elektrik ve elektromanyetik testlerine (50 MHz - 20 GHz) yönelik faaliyetlerini de sürdürmektedir.</p>
                        <p>Malzemelerin termal ve elektriksel özellikler ölçümü ile mikroyapı karakterizasyonuna yönelik hizmet vermektedir.</p>
                        <p>TEKNOMA tarafından tasarıma dayalı ince film kaplama üniteleri, vakum sistemleri ve aksamları ile sputter, ion demeti vb. sistemleri siparişe dayalı olarak imal edilmektedir.</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="company-images">
                        <figure className="wp-caption">
                          <img 
                            src={molybdenumImage} 
                            alt="Mikroskop camına kaplanmış Molibdenum ince filmler" 
                            className="img-fluid"
                          />
                          <figcaption className="wp-caption-text">Mikroskop camına kaplanmış Molibdenum ince filmler</figcaption>
                        </figure>
                        <figure className="wp-caption">
                          <img 
                            src={compositeImage} 
                            alt="Aramid ve cam elyaf takviyeli polimer kompozit levhalar" 
                            className="img-fluid"
                          />
                          <figcaption className="wp-caption-text">Aramid ve cam elyaf takviyeli polimer kompozit levhalar</figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="award-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h5 className="award-title">Bilim, Sanayi ve Teknoloji Bakanı Nihat Ergün tarafından firmamıza ödül verilmiştir</h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="award-image">
                        <img src={awardImage1} alt="Ödül" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="award-description">
                        <p>Teknoma Ltd. Şti. üstün nitelikte Ar-Ge projesi gerçekleştiren firmalardan birisi olarak seçilmiş ve 09 Mart 2013 tarihinde İzmir de gerçekleşen Üniversite-Sanayi İşbirliği Bölgesel Toplantısında Bilim, Sanayi ve Teknoloji Bakanlığı tarafından ödül kazanmıştır.</p>
                        <p>"Antistatik Uygulamalar: Mıknatıssal Saçtırma ile Metal Kaplanmış Fiberler" isimli proje ile ödüle layık görülmüştür.</p>
                        <p>Ayrıca, firmamız aynı etkinlikte gerçekleşen ve Bilim, Sanayi ve Teknoloji Bakanlığı Müsteşarı yönetimindeki panele de davet edilerek Üniversite-Sanayi İşbirliğine yönelik çözümler konusunda katkı sağlamıştır.</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="additional-award-image">
                        <img src={awardImage2} alt="Ödül Sertifikası" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;